import React, { useState } from 'react';
import { Play } from 'lucide-react';

const FEATURED_VIDEOS = [
  { url: 'https://customer-assets.emergentagent.com/job_669fbeff-f080-4dde-bc05-7b6a5c8193e8/artifacts/mtiyk1gt_0ff4f86dc05b7b26_5f604f9fbb3f44688380cda17e5e7d01.mp4', title: '2018 Itasca CC Offensive Highlights', stats: ['#1 Offense in MCAC', 'MCAC Championship', 'Coach of the Year', '#2 National Ranking'] },
  { url: 'https://customer-assets.emergentagent.com/job_669fbeff-f080-4dde-bc05-7b6a5c8193e8/artifacts/ho937uzp_7bc4005ebf9811b1_565b1ac89f4f480cb7686e9424e63f24.mp4', title: '2019 Itasca CC Offensive Highlights', stats: ['#1 Offense in MCAC', 'Top 10 NJCAA Offense', 'School Record Total Offense', 'School Record PPG'] },
];

const OTHER_VIDEOS = [
  { url: 'https://customer-assets.emergentagent.com/job_669fbeff-f080-4dde-bc05-7b6a5c8193e8/artifacts/179pgd18_c8775cc506c155b7_d14addb2d0a54b70bf90ab0daa708fd7.mp4', title: 'Team Development' },
  { url: 'https://customer-assets.emergentagent.com/job_669fbeff-f080-4dde-bc05-7b6a5c8193e8/artifacts/w6zqprqq_Grind.mov', title: 'The Grind' },
  { url: 'https://customer-assets.emergentagent.com/job_669fbeff-f080-4dde-bc05-7b6a5c8193e8/artifacts/cn4b0cfn_OFF%20SEASON.mp4', title: 'Off Season Training' },
  { url: 'https://customer-assets.emergentagent.com/job_669fbeff-f080-4dde-bc05-7b6a5c8193e8/artifacts/032bgmz0_Ring.mov', title: 'Conference Championship' },
];

const PHOTOS = [
  { url: 'https://customer-assets.emergentagent.com/job_669fbeff-f080-4dde-bc05-7b6a5c8193e8/artifacts/d58orriz_9F339644-1375-4C4F-895C-D6DABE0B6D00.jpg' },
  { url: 'https://customer-assets.emergentagent.com/job_669fbeff-f080-4dde-bc05-7b6a5c8193e8/artifacts/vzqmpfcr_E057C123-8DAD-4BCD-906A-E2AEB69D8269.JPG' },
  { url: 'https://customer-assets.emergentagent.com/job_669fbeff-f080-4dde-bc05-7b6a5c8193e8/artifacts/9t893yio_IMG_0656.JPG' },
  { url: 'https://customer-assets.emergentagent.com/job_669fbeff-f080-4dde-bc05-7b6a5c8193e8/artifacts/i97q8zxj_IMG_0727.JPG' },
  { url: 'https://customer-assets.emergentagent.com/job_669fbeff-f080-4dde-bc05-7b6a5c8193e8/artifacts/kxk8wi9t_IMG_1636%202.PNG' },
  { url: 'https://customer-assets.emergentagent.com/job_669fbeff-f080-4dde-bc05-7b6a5c8193e8/artifacts/ahd1it5n_IMG_2873.JPG' },
  { url: 'https://customer-assets.emergentagent.com/job_669fbeff-f080-4dde-bc05-7b6a5c8193e8/artifacts/smdhm22r_IMG_5693%202.JPG' },
  { url: 'https://customer-assets.emergentagent.com/job_669fbeff-f080-4dde-bc05-7b6a5c8193e8/artifacts/mj61pgcu_IMG_5766%202.JPG' },
  { url: 'https://customer-assets.emergentagent.com/job_669fbeff-f080-4dde-bc05-7b6a5c8193e8/artifacts/4tbr1poq_IMG_5881.JPG' },
  { url: 'https://customer-assets.emergentagent.com/job_669fbeff-f080-4dde-bc05-7b6a5c8193e8/artifacts/ddaytssc_IMG_5937%202.JPG' },
  { url: 'https://customer-assets.emergentagent.com/job_669fbeff-f080-4dde-bc05-7b6a5c8193e8/artifacts/ycfbqlsr_IMG_7092%202.JPG' },
];

export default function Media() {
  const [playing, setPlaying] = useState(null);

  return (
    <div className="bg-gray-950 text-white pt-20">
      <section className="py-16 px-6 border-b border-gray-800">
        <div className="container mx-auto max-w-4xl text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Media</h1>
          <p className="text-lg text-gray-400">Game highlights, coaching moments, and program development.</p>
        </div>
      </section>

      {/* Featured Highlights */}
      <section className="py-16 px-6">
        <div className="container mx-auto max-w-5xl">
          <h2 className="text-2xl font-bold mb-8">Featured Highlights</h2>
          <div className="grid md:grid-cols-2 gap-8">
            {FEATURED_VIDEOS.map((v) => (
              <div key={v.title}>
                <div className="relative rounded-xl overflow-hidden shadow-xl ring-2 ring-blue-600/30 cursor-pointer group" onClick={() => setPlaying(v)}>
                  <div className="relative aspect-video bg-gray-900">
                    <video src={v.url} className="w-full h-full object-cover" preload="metadata" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent flex items-center justify-center">
                      <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform"><Play className="h-8 w-8 text-blue-600 ml-1" /></div>
                    </div>
                  </div>
                </div>
                <h3 className="text-lg font-bold mt-4 mb-2">{v.title}</h3>
                <div className="flex flex-wrap gap-2">
                  {v.stats.map((s) => (<span key={s} className="bg-gray-800 text-gray-300 text-xs px-3 py-1 rounded-full border border-gray-700">{s}</span>))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Other Videos */}
      <section className="py-12 px-6 bg-gray-900 border-y border-gray-800">
        <div className="container mx-auto max-w-5xl">
          <h2 className="text-2xl font-bold mb-8">More Video</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {OTHER_VIDEOS.map((v) => (
              <div key={v.title} className="cursor-pointer group" onClick={() => setPlaying(v)}>
                <div className="relative aspect-video bg-gray-800 rounded-xl overflow-hidden">
                  <video src={v.url} className="w-full h-full object-cover" preload="metadata" />
                  <div className="absolute inset-0 bg-black/40 flex items-center justify-center"><Play className="h-8 w-8 text-white group-hover:scale-110 transition-transform" /></div>
                </div>
                <p className="text-sm font-medium text-gray-300 mt-2">{v.title}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Photo Gallery */}
      <section className="py-16 px-6">
        <div className="container mx-auto max-w-5xl">
          <h2 className="text-2xl font-bold mb-8">Gallery</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
            {PHOTOS.map((p) => (
              <div key={p.url} className="aspect-square rounded-xl overflow-hidden">
                <img src={p.url} alt="" className="w-full h-full object-cover hover:scale-105 transition-transform" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* LinkedIn Embed */}
      <section className="py-16 px-6 bg-gray-900 border-t border-gray-800">
        <div className="container mx-auto max-w-2xl text-center">
          <h2 className="text-2xl font-bold mb-8">Featured Update</h2>
          <div className="bg-gray-950 rounded-xl p-6 border border-gray-800">
            <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:7421298951032672256" height="600" width="100%" frameBorder="0" allowFullScreen title="LinkedIn Post" className="rounded-lg" />
          </div>
        </div>
      </section>

      {/* Video Modal */}
      {playing && (
        <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4" onClick={() => setPlaying(null)}>
          <div className="relative max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setPlaying(null)} className="absolute -top-10 right-0 text-white hover:text-gray-300 font-bold">Close</button>
            <video src={playing.url} controls autoPlay className="w-full rounded-lg" />
            <p className="text-white text-center mt-4">{playing.title}</p>
          </div>
        </div>
      )}
    </div>
  );
}
